<div id="layout-wrapper">

   <div>
    <p>horizontal</p>
    <p>topbar</p>
  </div>

  <app-horizontaltopbar></app-horizontaltopbar>

  <div class="main-content" style="min-height: 720px;">
    <div class="page-content tamano " style="padding-top: calc(40px);" >
      <!-- mospina 14-10-26 EPT-2103 Avisos institucionales dentro del sistema -->
      <app-avisos-sistema></app-avisos-sistema>
      <router-outlet></router-outlet>
    </div>
  </div>

  <app-footer></app-footer>
  <app-rightsidebar></app-rightsidebar>
</div>
